import { z } from 'zod';
import { insuranceClaimsIdSchema } from './insurance-claims-claim.contract.js';
import { insuranceClaimsCommunicationsNoticeDeliveryAvailabilitySchema } from './insurance-claims-communications-notice-delivery.contract.js';
import { insuranceClaimsDocumentsNoticeArtifactAvailabilitySchema } from './insurance-claims-documents-notice-artifact.contract.js';
export const insuranceClaimsAobNoticeOwnerEvidenceCapability = 'insurance-claims.aob-notice-owner-evidence.v1';
export const insuranceClaimsAobNoticeOwnerEvidenceItemSchema = z.strictObject({
    noticeId: insuranceClaimsIdSchema,
    noticeRevision: z.number().int().positive(),
    documents: insuranceClaimsDocumentsNoticeArtifactAvailabilitySchema,
    communications: insuranceClaimsCommunicationsNoticeDeliveryAvailabilitySchema,
});
export const insuranceClaimsAobNoticeOwnerEvidenceSchema = z.strictObject({
    contractVersion: z.literal(insuranceClaimsAobNoticeOwnerEvidenceCapability),
    claimId: insuranceClaimsIdSchema,
    projectId: insuranceClaimsIdSchema,
    items: z.array(insuranceClaimsAobNoticeOwnerEvidenceItemSchema).max(250),
}).superRefine((value, context) => {
    const noticeIds = value.items.map(({ noticeId }) => noticeId);
    if (new Set(noticeIds).size !== noticeIds.length) {
        context.addIssue({
            code: 'custom', path: ['items'], message: 'Owner evidence must contain each notice once.',
        });
    }
});
export const insuranceClaimsAobNoticeOwnerEvidenceResponseSchema = z.strictObject({
    data: insuranceClaimsAobNoticeOwnerEvidenceSchema,
});
//# sourceMappingURL=insurance-claims-aob-notice-owner-evidence.contract.js.map